import { PortalSection } from "./portal-ui";

interface DescriptionCardProps {
  description?: string;
}

/** The fund's own description, set as a readable column of prose. */
export function DescriptionCard({ description }: DescriptionCardProps) {
  if (!description) return null;

  return (
    <PortalSection title="About">
      <div
        className="prose max-w-[68ch] text-[17px] leading-[1.7] text-foreground/85 prose-headings:font-semibold prose-headings:tracking-tight prose-headings:text-foreground prose-h2:text-xl prose-h3:text-lg prose-p:my-4 prose-a:font-medium prose-a:text-foreground prose-a:underline-offset-[3px] prose-strong:text-foreground prose-li:my-1 prose-li:marker:text-muted-foreground/60 prose-hr:border-border"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </PortalSection>
  );
}
